import { NumberInput, SelectInput, TextInput } from "@dzambalaorg/mui-inputs-core";
import { RichTextEditor } from "@dzambalaorg/mui-inputs-draft";
import { EntityInput } from "@dzambalaorg/mui-inputs-entity";
import { AvatarInput } from "@dzambalaorg/mui-inputs-image-firebase";
import { TemplateAssetInput } from "@dzambalaorg/mui-inputs-asset";
import { ModuleType, TemplateStatus, TokenType } from "@framework/types";
import { DialogMode } from "@framework/shared";
import { FormGrid } from "@dzambalaorg/ui-kit";

export interface ICollectionTemplateDialogFormProps {
  mode: DialogMode;
}

export const CollectionTemplateDialogForm = (props: ICollectionTemplateDialogFormProps) => {
  const { mode } = props;

  const columns = mode === "edit" ? [2, 2, 1, 1, 3] : [3, 1, 1, 3];

  return (
    <FormGrid columns={columns}>
      <TextInput name="title" />
      <NumberInput name="amount" />
      <EntityInput
        name="contractId"
        controller="contracts"
        fetchData={{
          contractType: [TokenType.ERC721],
          contractModule: [ModuleType.COLLECTION],
        }}
        readOnly={mode === "edit"}
      />
      {mode === "edit" && <SelectInput name="templateStatus" options={TemplateStatus} />}

      <TemplateAssetInput
        autoSelect
        multiple
        prefix="price"
        tokenType={{ disabledOptions: [TokenType.ERC721, TokenType.ERC998] }}
      />

      <RichTextEditor name="description" />

      <AvatarInput name="imageUrl" />
      <FormGrid.Empty />
      <FormGrid.Empty />
    </FormGrid>
  );
};
